import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RbacState } from './rbac.state';

export const selectRbacState = createFeatureSelector<RbacState>('rbac');

// Stable empty array used until RBAC permissions are loaded.
const NO_PERMISSIONS: string[] = [];

// Selects the permissions granted by the backend.
// Returns an empty list when RBAC is not loaded or no permissions are granted.
export const selectPermissions = createSelector(
  selectRbacState,
  (s) => s?.rbac?.permissions ?? NO_PERMISSIONS
);